<div class="card pl-3 pr-3 pb-3 pt-2 mb-2 mt-3">
  <ng-container *ngFor="let item of items | itemOrder; index as i">
    <div [ngClass]="i !== selectedItemIndex ? 'border-bottom' : ''"
         class="d-flex justify-content-between clickable pt-2 align-text-bottom">
      <input id="quantityInput" type="number" class="quantity text-muted mr-2 p-0" #quantity
             (keyup.enter)="$event.target.blur()" (focusout)="updateQuantity(item, quantity.valueAsNumber)"
             [value]="item.quantity" [disabled]="characterCreate">
      <div (click)="showItem(i)" class="w-100 align-items-start">
        <p class="font-weight-bold text-wrap my-2">{{item.name}}</p>
      </div>

      <fa-icon (click)="showItem(i)" [icon]="selectedItemIndex !== i ? faAngleDown : faAngleUp"
               class="fa mr-1" style="font-size: 1.25em"></fa-icon>
    </div>
    <div *ngIf="i === selectedItemIndex" class="d-flex flex-column bg-light pt-2 pr-3 pl-3 border pb-2 slide"
         style="font-size: 0.8em" @slideUpDown>
      <div *ngIf="selectedItemIndex === i">
        <span *ngIf="item.type"><em>{{item.type}}</em><br><br></span>
        <p>
          <span *ngIf="item.weight"><strong>Weight: </strong>{{item.weight}}<br></span>
          <span *ngIf="item.damageType"><strong>Damage Type: </strong>{{item.damageType}}<br></span>
          <span *ngIf="item.damage"><strong>Damage: </strong>{{item.damage}}<br></span>
          <span *ngIf="item.range"><strong>Range: </strong>{{item.range}}<br></span>
          <span *ngIf="item.rarity"><strong>Item Rarity: </strong>{{item.rarity}}<br></span>
          <span *ngIf="item.properties">
          <strong>Properties: </strong>
          <span *ngFor="let prop of item.properties">
            {{prop}}</span><br>
        </span>
          <span *ngIf="item.description" [innerHTML]="item.description | bypassHtml"></span>
        </p>
      </div>
      <div class="w-100">
        <fa-icon *ngIf="!characterCreate" (click)="editItem(i)" [icon]="faPencil" class="fa mr-2 float-right clickable"
                 style="font-size: 1.25em"></fa-icon>
        <button *ngIf="characterCreate" class="btn btn-sm btn-main text-white float-right" (click)="addItem(item)">
          Add Item
        </button>
      </div>
    </div>
  </ng-container>
</div>
                                                                                                      
